(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/common/assets/javascripts/dialog.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/common/assets/javascripts/dialog.js');
"use strict";


const BetterDialog = svs.components.lbUi.betterDialog.BetterDialog;
const aliasDialog = new BetterDialog().setIcon('exclamation-sign').setTitle('Alias').addText('För att spela Bingo behöver du sätta ett alias.').addAction('Sätt alias', () => {
  const url = "".concat(svs.core.urlMapping.get('myProfileHome'), "/uppgifter/alias?returnUrl=").concat(svs.utils.url.currentPathEncodedParams());
  svs.utils.url.navigate(url);
}).compose();
setGlobal('svs.bingo_react.components.common.dialog', {
  aliasDialog
});

 })(window);